module.exports = __webpack_public_path__ + "img/close2.8dec8f9b.svg";